// extracted by mini-css-extract-plugin
export default {"container":"r2-z","list":"s2-z"};